import styled from "styled-components";

import { flex } from "../../../helpers/mixins";
import media from "../../../helpers/media";
import { fromThemeProps } from "../../../helpers/utilities";

const StyledHero = styled.div`
    position: relative;
    ${flex({ dir: "column", jc: "space-between", ai: "center" })};
    height: 600px;
    padding-top: ${fromThemeProps("headerHeight")};
    width: 100%;

    background: linear-gradient(to bottom, rgba(134, 64, 47, .7), transparent), url(${props => props.backgroundSm}) bottom center / cover;
    background-position-x: 75%;

    text-align: center;

    ${media.xs`
        height: 75vh;
        min-height: 600px;

        background: linear-gradient(to left, rgba(134, 64, 47, .9), transparent), url(${props => props.backgroundLg}) bottom center / cover;
    `}

    ${media.lg`
        height: 75vh;

        background: linear-gradient(to left, rgba(134, 64, 47, .9), transparent), url(${props => props.backgroundLg}) center center / cover;
    `}
`

StyledHero.ContentContainer = styled.div`
    ${flex({ jc: "center", ai: "center" })};
    height: 100%;
    width: 100%;
`

StyledHero.Content = styled.div`
    height: 600px;
    width: 100%;
    padding-top: 1.5rem;
    ${flex({ dir: "column", jc: "space-between", ai: "center" })};
    ${media.xs`
        padding-top: 0;
        width: 400px; 

        transform:translateX(16vw);
        justify-content: center;
    `}
    ${media.lg`
        width: 600px;
        transform:translateX(21vw);
    `}
`

export default StyledHero;


// WEBPACK FOOTER //
// ./src/styles/styledComponents/blocks/styledHero.js